import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDataDisplayerPagination } from "../../components/DataDisplayer/DataDisplayer";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { EmptyBrandModel, IBrandModel } from "./BrandsApp";
import { ISearchParam } from "../BaseApp";

interface IBrandsState {
    brands: IBrandModel[],
    selectedBrands: IBrandModel[],
    searchParams: ISearchParam[],
    loading: boolean,
    pagination: IDataDisplayerPagination,
    search?: string
}

const initialState: IBrandsState = {
    brands: [],
    selectedBrands: [],
    searchParams: [],
    loading: false,
    pagination: {
        count: 0,
        current_page: 0,
        total_pages: 0
    }
}

const brandsSlice = createSlice({
    name: "brands",
    initialState,
    reducers: {
        updateAllBrands: (state: IBrandsState, action: PayloadAction<IBrandModel[]>) => {
                state.brands = action.payload
        },
        addNewBrand: (state: IBrandsState, action: PayloadAction<IBrandModel>) => {
            let brands = state.brands

            if (brands.filter(brand => brand.id === action.payload.id).length === 0){
                state.brands.push(action.payload)
            }

        },
        deleteBrand: (state: IBrandsState, action: PayloadAction<{ id: number }>) => {
            const payload = action.payload
            
            let brands = state.brands

            brands = brands.filter(brand => brand.id !== payload.id)

            state.brands = brands

        },
        updateBrand: (state: IBrandsState, action: PayloadAction<IBrandModel>) => {
            let brands = state.brands
            
            if (brands && brands.length > 0){
                brands.map((brand) => {
                    if (brand.id === action.payload.id){

                        const locationIndex = brands.findIndex(brand => brand.id === action.payload.id)
                        brands[locationIndex] = action.payload

                    }
                })
            }

            state.brands = brands

        },
        updateBrandsLoadingStatus: (state: IBrandsState, action: PayloadAction<{ loading: boolean }>) => {
            state.loading = action.payload.loading
        },
        updateBrandsPagination: (state: IBrandsState, action: PayloadAction<IDataDisplayerPagination>) => {
            state.pagination = action.payload
        },
        updateBrandsSearch: (state: IBrandsState, action: PayloadAction<{ search: string }>) => {
            state.search = action.payload.search
        },
        updateBrandsSearchParams: (state: IBrandsState, action: PayloadAction<ISearchParam[]>) => {
            state.searchParams = action.payload
        },
        setSelectedBrands: (state: IBrandsState, action: PayloadAction<IBrandModel[]>) => {
            state.selectedBrands = action.payload
        },
    }
})

/**
 * Return all brand
 */
export const useReturnAllBrands = () => useSelector((state: RootState) => state.brands.brands)

/**
 * Retrun single brand
 */
export const useReturnSingleBrand = (id: number) => {
    const brands = useReturnAllBrands()

    let brand: IBrandModel = EmptyBrandModel

    if (brands.length > 0){
        brands.map((singleBrand) => {
            if (singleBrand.id === id){
                brand = singleBrand
            }
        })
    }

    return brand

}

/**
 * Return brands loading status
 */
export const useReturnBrandsLoadingStatus = () => useSelector((state: RootState) => state.brands.loading)

/**
 * Return brands pagination
 */
export const useReturnBrandsPagination = () => useSelector((state: RootState) => state.brands.pagination)

/**
 * Return brands search
 */
export const useReturnBrandsSearch = () => useSelector((state: RootState) => state.brands.search)

/**
 * Return brands search params
 */
export const useReturnBrandsSearchParams = () => useSelector((state: RootState) => state.brands.searchParams)

/**
 * Return selected brands
 */
export const useReturnSelectedBrands = () => useSelector((state: RootState) => state.brands.selectedBrands)

export const { updateAllBrands, addNewBrand, deleteBrand, updateBrand, updateBrandsLoadingStatus, updateBrandsPagination, updateBrandsSearch, updateBrandsSearchParams, setSelectedBrands } = brandsSlice.actions
export default brandsSlice.reducer